import request from '../../request.js'
//e签宝 签署订单

//签署合同
export const startFlow = function (data) {
    return request({
        url: '/esignOrder/startFlow',
        method: 'post',
        data
    })
}

//分页列表
export const getPageTableList = function (data) {
    return request({
        url: '/esignOrder/getPageTableList',
        method: 'post',
        data
    })
}

//获取信息
export const getObjectById = function (data) {
    return request({
        url: '/esignOrder/getObjectById',
        method: 'post',
        data
    })
}